import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Users, Award, Wrench, ArrowRight } from "lucide-react";
import { useLang } from "../context/I18nContext";
import { COMPANY_VIDEO } from "../config/sectionVideos";

export default function About() {
  const { t } = useLang();
  return (
    <div className="page-shell" data-testid="about-page">
      <section className="site-container page-hero">
        <div className="eyebrow mb-6">{t("about.eyebrow")}</div>
        <h1 className="page-title">
          {t("about.h1.1")}<br/><span className="italic-accent">{t("about.h1.italic")}</span> {t("about.h1.2")}
        </h1>
        <p className="copy-lead mt-8 text-base md:text-lg">
          {t("about.intro")}
        </p>
      </section>

      <section className="site-container section-block">
        <div className="grid grid-cols-1 lg:grid-cols-2 surface-panel">
          <div className="relative min-h-[440px] overflow-hidden bg-[#132E4A] border-b lg:border-b-0 lg:border-r border-white/10">
            <video
              src={COMPANY_VIDEO.src}
              poster={COMPANY_VIDEO.poster}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              aria-label="Moderne Gebäudetechnik in Bewegung"
              className="absolute inset-0 w-full h-full object-cover opacity-90 section-video-anim"
              data-testid="company-mission-video"
            />
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-transparent via-transparent to-[#0A1F38]/30"/>
          </div>
          <div className="p-8 md:p-10 lg:p-14">
            <div className="eyebrow mb-5">{t("about.mission")}</div>
            <h2 className="section-title mb-7">
              {t("about.h2.1")}<br/>{t("about.h2.2")} <span className="italic-accent">{t("about.h2.italic")}</span>
            </h2>
            <p className="text-white/65 leading-relaxed mb-10">
              {t("about.missionText")}
            </p>
            <Link to="/kontakt" className="btn-primary" data-testid="about-cta">
              {t("about.cta")} <ArrowRight size={14}/>
            </Link>
          </div>
        </div>
      </section>

      <section className="site-container section-block">
        <div className="eyebrow mb-10">{t("about.values")}</div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          <Value n="01" icon={Leaf} title={t("about.v1.title")} desc={t("about.v1.desc")}/>
          <Value n="02" icon={Users} title={t("about.v2.title")} desc={t("about.v2.desc")}/>
          <Value n="03" icon={Award} title={t("about.v3.title")} desc={t("about.v3.desc")}/>
          <Value n="04" icon={Wrench} title={t("about.v4.title")} desc={t("about.v4.desc")}/>
        </div>
      </section>
    </div>
  );
}

function Value({ n, icon: Icon, title, desc }) {
  return (
    <div className="technical-card p-8 lg:p-10 min-h-[240px]">
      <div className="flex items-start justify-between mb-12">
        <div className="font-display text-2xl text-white/40">{n}</div>
        <Icon size={20} strokeWidth={1.4} className="text-white/60"/>
      </div>
      <div className="font-display text-xl mb-3">{title}</div>
      <div className="text-sm text-white/60 leading-relaxed">{desc}</div>
    </div>
  );
}
